"use strict";
/**
 * Created by fan on 2/20/17.
 */
exports.__esModule = true;
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var universal;
            (function (universal) {
                var schema;
                (function (schema) {
                    var logic;
                    (function (logic) {
                        /**
                         * Hold the field lists for universal schema.
                         *
                         * Note: Not checking duplicated keys. So whatever incoming it got,
                         * will be the way it is.
                         */
                        var FieldList = /** @class */ (function () {
                            function FieldList(listData) {
                                listData = listData || {};
                                this.templateName = listData.templateName;
                                if (listData.inputs) {
                                    this.inputs = listData.inputs.slice();
                                }
                                if (listData.outputs) {
                                    this.outputs = listData.outputs.slice();
                                }
                                if (listData.tableInputs) {
                                    this.tableInputs = listData.tableInputs.slice();
                                }
                                if (listData.tableOutputs) {
                                    this.tableOutputs = listData.tableOutputs.slice();
                                }
                                if (listData.categories) {
                                    this.categories = listData.categories.slice();
                                }
                            }
                            FieldList.prototype.findInInputs = function (key) {
                                return this.inputs ?
                                    this.inputs.find(function (item) { return item.key == key; }) : undefined;
                            };
                            FieldList.prototype.findInOutputs = function (key) {
                                return this.outputs ?
                                    this.outputs.find(function (item) { return item.key == key; }) : undefined;
                            };
                            FieldList.prototype.findInInputTables = function (key) {
                                return this.tableInputs ?
                                    this.tableInputs.find(function (item) { return item.key == key; }) : undefined;
                            };
                            FieldList.prototype.findInOutputTables = function (key) {
                                return this.tableOutputs ?
                                    this.tableOutputs.find(function (item) { return item.key == key; }) : undefined;
                            };
                            FieldList.prototype.findInCategories = function (key) {
                                return this.categories ?
                                    this.categories.find(function (item) { return item.key == key; }) : undefined;
                            };
                            FieldList.prototype.getFieldListData = function () {
                                return {
                                    templateName: this.templateName,
                                    inputs: this.inputs ? this.inputs.slice() : undefined,
                                    outputs: this.outputs ? this.outputs.slice() : undefined,
                                    tableInputs: this.tableInputs ? this.tableInputs.slice() : undefined,
                                    tableOutputs: this.tableOutputs ? this.tableOutputs.slice() : undefined,
                                    categories: this.categories ? this.categories.slice() : undefined
                                };
                            };
                            return FieldList;
                        }());
                        logic.FieldList = FieldList;
                    })(logic = schema.logic || (schema.logic = {}));
                })(schema = universal.schema || (universal.schema = {}));
            })(universal = acts.universal || (acts.universal = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.universal.schema.logic;
//# sourceMappingURL=schema-fieldlist.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-builder/app/js/logic/schema-fieldlist.js